// Centralised Italian content for the XL Brokers website
export const COMPANY = {
  name: "XL Brokers",
  legalName: "XL Brokers SRL",
  tagline: "We change the way you insure yourself",
  payoff: "Brokeraggio assicurativo per chi mette il cliente al centro.",
  phone: "051 0034912",
  email: "info@xlbrokers.it",
  pec: "xlbrokers@pec.it",
  address: "Via di Corticella 184/10 — 40128 Bologna",
  vat: "CF / P.IVA 04234881201",
  rui: "B000767919",
  ruiSection: "Sezione B",
  ruiUrl: "https://ruipubblico.ivass.it/rui-pubblica/ng/#/workspace/registro-unico-intermediari",
};

export const SERVIZI = [
  {
    slug: "analisi-dei-rischi",
    title: "Analisi dei Rischi",
    short: "Identifichiamo, misuriamo e mappiamo i rischi del tuo business.",
    body:
      "Studiamo la tua attività con un approccio sartoriale: ispezioni in loco, analisi documentale e mappatura dei processi per individuare ogni esposizione — patrimoniale, operativa, legale e reputazionale. Il risultato è un quadro chiaro, scritto, condivisibile con la tua direzione.",
    bullets: [
      "Audit assicurativo delle coperture esistenti",
      "Risk mapping per linea di business",
      "Quantificazione delle esposizioni",
      "Roadmap di mitigazione",
    ],
  },
  {
    slug: "programmi-assicurativi",
    title: "Programmi Assicurativi",
    short: "Coperture su misura, costruite sul tuo profilo di rischio.",
    body:
      "Progettiamo e negoziamo programmi assicurativi personalizzati con le migliori compagnie del mercato italiano ed internazionale. Ottimizziamo premi e franchigie senza compromessi sulle garanzie essenziali.",
    bullets: [
      "Coperture multi-ramo coordinate",
      "Wording su misura per il cliente",
      "Negoziazione con il mercato",
      "Revisione annuale del programma",
    ],
  },
  {
    slug: "risk-assessment",
    title: "Risk Assessment",
    short: "Valutazioni tecniche per decisioni strategiche.",
    body:
      "Forniamo analisi tecniche approfondite — anche con ingegneri specializzati — per supportare scelte di investimento, M&A, espansione produttiva o cantieri complessi. Trasformiamo il rischio in un dato gestibile.",
    bullets: [
      "Due diligence assicurativa",
      "Valutazione property & casualty",
      "Stima dei danni potenziali",
      "Report tecnici per board",
    ],
  },
  {
    slug: "convenzioni",
    title: "Convenzioni",
    short: "Accordi quadro dedicati a categorie professionali ed associazioni.",
    body:
      "Per ordini professionali, associazioni di categoria e gruppi di aziende sviluppiamo convenzioni esclusive: prodotti studiati, condizioni dedicate e gestione amministrativa centralizzata.",
    bullets: [
      "Studio dei bisogni della categoria",
      "Selezione delle compagnie partner",
      "Wording dedicato",
      "Gestione e reportistica annuale",
    ],
  },
];

export const SETTORI = [
  {
    slug: "edilizia",
    title: "Edilizia",
    short: "Imprese di costruzione, general contractor e cantieri complessi.",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1600&q=80",
    body:
      "Coperture CAR/EAR, postuma decennale, RC professionale di progettazione, fidejussioni e garanzie di buon adempimento. Conosciamo il cantiere e parliamo la lingua del capo commessa.",
    coperture: [
      "CAR / EAR — tutti i rischi del costruttore",
      "Postuma decennale (D.Lgs. 122/2005)",
      "RC professionale tecnica",
      "Fidejussioni a prima richiesta",
      "Tutela legale e protezione del credito",
    ],
  },
  {
    slug: "impiantisti",
    title: "Impiantisti",
    short: "Imprese di installazione termoidraulica, elettrica e tecnologica.",
    image:
      "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1600&q=80",
    body:
      "Programmi assicurativi calibrati sui rischi della posa in opera, della responsabilità del prodotto e degli interventi presso terzi.",
    coperture: [
      "RC dell'installatore",
      "Garanzia postuma sugli impianti",
      "All Risks attrezzature e furgoni",
      "Tutela legale d'impresa",
    ],
  },
  {
    slug: "piccole-e-medie-imprese",
    title: "Piccole e Medie Imprese",
    short: "Programmi assicurativi modulari per la spina dorsale dell'economia italiana.",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
    body:
      "Una governance del rischio chiara per le PMI: un solo interlocutore, un piano d'azione annuale e coperture che crescono con l'azienda.",
    coperture: [
      "All Risks patrimonio aziendale",
      "RC verso terzi e prestatori d'opera",
      "Cyber risk e business interruption",
      "Tutela del credito",
      "D&O — Responsabilità degli amministratori",
    ],
  },
  {
    slug: "employee-benefit",
    title: "Employee Benefit",
    short: "Welfare aziendale e protezione delle persone che fanno la differenza.",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80",
    body:
      "Progettiamo piani sanitari, previdenziali e di protezione collettiva che rafforzano l'attrattività dell'azienda e fidelizzano i talenti.",
    coperture: [
      "Polizze sanitarie collettive",
      "Infortuni professionali ed extra-professionali",
      "Vita TCM di gruppo",
      "Fondi previdenza integrativa",
    ],
  },
  {
    slug: "professionisti",
    title: "Professionisti",
    short: "Studi e liberi professionisti che mettono la firma sul proprio lavoro.",
    image:
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1600&q=80",
    body:
      "RC professionale, tutela legale e protezione del patrimonio personale per chi opera con la massima responsabilità.",
    coperture: [
      "RC Professionale per ogni categoria",
      "Tutela legale e penale",
      "Cyber risk per studi",
      "Protezione patrimoniale del professionista",
    ],
  },
  {
    slug: "area-sanitaria",
    title: "Area Sanitaria",
    short: "Strutture, medici, odontoiatri e operatori del comparto salute.",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1600&q=80",
    body:
      "Soluzioni specialistiche per il rischio sanitario, con wording costruiti sulle ultime normative (Legge Gelli-Bianco) e sulla giurisprudenza più recente.",
    coperture: [
      "RC professionale medici e odontoiatri",
      "RC strutture sanitarie e RSA",
      "Tutela legale dell'esercente sanitario",
      "Polizze infortuni dedicate",
    ],
  },
  {
    slug: "amministratori-di-condominio",
    title: "Amministratori di Condominio",
    short: "Programmi globali fabbricato e RC dello studio dell'amministratore.",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1600&q=80",
    body:
      "Affianchiamo lo studio dell'amministratore nell'individuazione delle coperture per il condominio e nella gestione dei sinistri.",
    coperture: [
      "Globale fabbricato",
      "RC dell'amministratore",
      "Tutela legale del condominio",
      "Gestione sinistri dedicata",
    ],
  },
  {
    slug: "privati-e-famiglie",
    title: "Privati e Famiglie",
    short: "La protezione del tuo patrimonio, della casa e delle persone che ami.",
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1600&q=80",
    body:
      "Un consulente personale per le scelte assicurative della famiglia: casa, auto, salute, viaggi, previdenza e tutela del patrimonio.",
    coperture: [
      "Casa e patrimonio domestico",
      "Salute e infortuni della famiglia",
      "Viaggi, hobby e sport",
      "Previdenza complementare",
    ],
  },
];

// Assistart — canale editoriale (podcast Spotify + video YouTube) su temi assicurativi.
// Non è un ramo di rischio, è un progetto di divulgazione firmato XL Brokers.
export const ASSISTART = {
  slug: "assistart",
  title: "Assistart",
  claim: "Le assicurazioni, spiegate bene.",
  intro:
    "Assistart è il canale editoriale di XL Brokers: un podcast su Spotify e una serie di video su YouTube in cui parliamo di assicurazioni con un linguaggio finalmente chiaro. Casi reali, interviste, guide pratiche e piccole lezioni per capire come proteggere davvero se stessi, la propria famiglia e la propria impresa.",
  spotifyUrl: "https://open.spotify.com/show/3zuz5tRj6yOmGNWbKMAPuS",
  youtubeUrl: "https://www.youtube.com/@AssiStart",
  cover:
    "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=1600&q=80",
  episodes: [
    {
      n: 59,
      title: "Spendi 15.000€ di polizze ogni anno ma non sei davvero protetto",
      desc: "Perché avere tante polizze non significa essere coperti: casi reali e coperture da ripensare.",
      url: "https://open.spotify.com/episode/6pqbvh4GqoUp40zPU2ufW2",
    },
    {
      n: 55,
      title: "Tuo figlio rompe qualcosa: sai che tocca a te pagare?",
      desc: "Responsabilità civile della famiglia: cosa copre davvero la polizza capofamiglia.",
      url: "https://open.spotify.com/episode/2j0hWenwogN9lM3HHaspgC",
    },
    {
      n: 52,
      title: "Hai ampliato la tua attività ma non hai aggiornato la polizza",
      desc: "Cambia il business, cambia il rischio. Perché la revisione annuale è decisiva.",
      url: "https://open.spotify.com/episode/69MYan4bwjEydT9DOFoDCt",
    },
    {
      n: 48,
      title: "Startup e assicurazioni: le polizze che ogni nuova impresa dovrebbe avere fin dal primo giorno",
      desc: "Ogni anno nascono 350.000 imprese in Italia. Ecco le coperture indispensabili dal giorno uno.",
      url: "https://open.spotify.com/episode/3MXsMKZYzVaVvFVgeh1XxT",
    },
  ],
};

export const VALORI = [
  {
    titolo: "Indipendenza",
    desc: "Siamo broker indipendenti: lavoriamo per te, non per le compagnie.",
  },
  {
    titolo: "Competenza",
    desc: "Conoscenza profonda dei rami tecnici e dei settori industriali italiani.",
  },
  {
    titolo: "Trasparenza",
    desc: "Wording chiaro, provvigioni dichiarate, nessuna sorpresa al rinnovo.",
  },
  {
    titolo: "Velocità",
    desc: "Rispondiamo subito. Quotazioni in giornata, sinistri gestiti senza attese.",
  },
];

export const NUMERI = [
  { kpi: "10+", label: "Anni di esperienza del team" },
  { kpi: "30+", label: "Compagnie assicurative partner" },
  { kpi: "850", label: "Clienti tra aziende e professionisti" },
  { kpi: "98%", label: "Feedback positivi" },
];

export const MEDIA = {
  hero:
    "https://images.unsplash.com/photo-1720247522884-75029b97e0b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpdGFsaWFuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDkzNTkxMnww&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMGVsZWdhbnR8ZW58MHx8fHwxNzgwOTM1OTEyfDA&ixlib=rb-4.1.0&q=85",
  services:
    "https://images.unsplash.com/photo-1595411425732-e69c1abe2763?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjB0ZXh0dXJlfGVufDB8fHx8MTc4MDkzNTkxMnww&ixlib=rb-4.1.0&q=85",
  contact:
    "https://images.unsplash.com/photo-1715593949273-09009558300a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxzb3BoaXN0aWNhdGVkJTIwb2ZmaWNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgwOTM1OTEyfDA&ixlib=rb-4.1.0&q=85",
  arch:
    "https://images.pexels.com/photos/13855840/pexels-photo-13855840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
